/* @jsxImportSource @emotion/react */
import React from 'react'

import { LinkedInIcon, TwitterXIcon } from '@slite/icons'

import { linkedInShareUrl, twitterShareUrl } from './constants'

// Brand icons ship with hardcoded fills.
const linkCss = {
  width: 24,
  height: 24,
  '& svg, & svg path': { fill: 'currentColor' },
  transition: 'opacity .2s cubic-bezier(.215,.61,.355,1)',
  '&:hover': { opacity: 0.6, color: 'var(--shade-05)' },
} as const

export function ArticleShareLinks(props: {
  shareUrl: string
  shareTitle: string
  shareOnXLabel: string
  shareOnLinkedInLabel: string
}) {
  return (
    <div className="flexbox flexbox-align-center flexbox-gap-16">
      <a
        href={twitterShareUrl(props.shareTitle, props.shareUrl)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={props.shareOnXLabel}
        className="flexbox-inline flexbox-centered shade-05"
        css={linkCss}
      >
        <TwitterXIcon size={17} aria-hidden="true" />
      </a>
      <a
        href={linkedInShareUrl(props.shareUrl)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={props.shareOnLinkedInLabel}
        className="flexbox-inline flexbox-centered shade-05"
        css={linkCss}
      >
        <LinkedInIcon size={20} aria-hidden="true" />
      </a>
    </div>
  )
}
